export const Colors = {
  background: '#FFFFFF',
  primary: '#4591F9',
  accent: '#04ECF6',
  light: '#FFFFFF',
  text: '#254D80',
  darkText: '#162E4C',
  error: '#FF005D',
  gradientStart: '#4591F9',
  gradientEnd: '#04ECF6',
  disabled: '#9797A6',
  active: '#40BE40',
  expired: '#FF4047',
};

export const Sizes = {
  xs: '0.75rem', // 12px
  smaller: '0.875', // 14px
  small: '0.9375rem', // 15px
  default: '1rem', // 16px
  medium: '1.125rem', // 18px
  lg: '1.25rem', // 20px
  xl: '1.5rem', // 24px
  xxl: '2rem', // 32px
  xxxl: '3rem', // 48px
};

export const FontWeight = {
  light: 300,
  normal: 400,
  medium: 500,
  bold: 700,
};

export const LineHeight = {
  xs: '1rem', // 16px
  small: '1.25rem', // 20px
  default: '1.875rem', // 30px
  xl: '3.75rem', // 60px
};
